import { c as _c } from "react/compiler-runtime";
import { IcoRedo16, IcoUndo16 } from '@onefootprint/icons';
import type { EditPlaybookHistoryItem } from '@onefootprint/request-types/dashboard';
import { IconButton, Tooltip, useShortcut } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import { useTranslateOperation } from './use-translate-operation';
type HistoryButtonKind = 'undo' | 'redo';
const SHORTCUTS: Record<HistoryButtonKind, string[]> = {
  undo: ['Meta', 'z'],
  redo: ['Meta', 'Shift', 'z']
};
export const HistoryButton = t0 => {
  const $ = _c(23);
  const {
    item,
    kind,
    onClick,
    isPending
  } = t0;
  const {
    translateOperation
  } = useTranslateOperation();
  let t1;
  if ($[0] !== item || $[1] !== kind || $[2] !== translateOperation) {
    t1 = item?.operation ? `${capitalize(kind)} "${translateOperation(item.operation)}"` : undefined;
    $[0] = item;
    $[1] = kind;
    $[2] = translateOperation;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const tooltip = t1;
  const t2 = SHORTCUTS[kind];
  let t3;
  if ($[4] !== item?.id || $[5] !== onClick) {
    t3 = () => onClick(item?.id);
    $[4] = item?.id;
    $[5] = onClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !item || isPending;
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      keys: t2,
      onShortcut: t3,
      disabled: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useShortcut(t5);
  const t6 = !tooltip;
  const t7 = kind === "undo" ? IcoUndo16 : IcoRedo16;
  let t8;
  if ($[11] !== item?.id || $[12] !== onClick) {
    t8 = () => onClick(item?.id);
    $[11] = item?.id;
    $[12] = onClick;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !item || isPending;
  let t10;
  if ($[14] !== kind || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <IconButton icon={t7} onClick={t8} disabled={t9} aria-label={kind} className="!rounded-full" />;
    $[14] = kind;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6 || $[21] !== tooltip) {
    t11 = <Tooltip key={tooltip} disabled={t6} content={tooltip}>{t10}</Tooltip>;
    $[19] = t10;
    $[20] = t6;
    $[21] = tooltip;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};